import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
class PasteBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.id = BehaviorType.paste;
        this.iframeBehaviorListeners = [{ type: this.id, listener: this.handler }];
    }
}
export default PasteBehavior;
